import React from 'react';

function ButtonAdd(props) {
    const { buttonText, type, parentId, handelSubmit, item } = props && props;
    return (
        <div 
            className="btn btnFeature text-2 w-100 border bg-light-1 p-3 my-2" 
            onClick={() => handelSubmit(type, parentId, item)}
            //type, parentId, item
        >
            <i className="fa fa-plus mr-2" aria-hidden="true"></i>
            {buttonText}
        </div>
    );
};

export default ButtonAdd;